// extracted by mini-css-extract-plugin
export default {"specification":"ingredient-details_specification__ZeORA","img":"ingredient-details_img__-iFnL","specification__item":"ingredient-details_specification__item__4kucr"};